export enum ScenarioAppliedAs {
  PLAN = 'Plan',
  FORECAST = 'Projection',
  PLAN_AND_FORECAST = 'PlanAndProjection',
}
